import React, { useEffect, useState, useRef } from "react";
import AptechHardwareImg from "../../assets/images/AptechHardwareImg.png";
import aptechaviationImg from "../../assets/images/aptechaviationImg.png";
import globalTrainingBannerImg from "../../assets/images/globalTrainingBannerImg.png";
import ComputerEducationImg from "../../assets/images/ComputerEducationImg.png";
import aptechEnglishLearningImg from "../../assets/images/aptechEnglishLearningImg.png";
import arenaAnimationImg from "../../assets/images/arenaAnimationImg.png";
import styles from "../OurBussiness/GlobalRetails.module.scss";
import classNames from "classnames";
import BreadCrumb from "../CommonComponents/BreadCrumb.tsx";
import { motion } from "framer-motion";

const GlobalRetails: React.FC = () => {
  const breadcrumb = [
    { title: "Home", link: "/" },
    { title: "Our Businesses", link: "/our-businesses" },
    { title: "International Retail", link: "" },
  ];

  return (
    <div className={styles.OverviewBusinessPage}>
      <BreadCrumb menu={breadcrumb} />
      <motion.div
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeInOut" }}
      >
        <Banner />
      </motion.div>
      <IndividualTraining />
    </div>
  );
};

export default GlobalRetails;

const Banner: React.FC = () => {
  const [isTablet, setIsTablet] = useState(window.innerWidth < 992);
  useEffect(() => {
    const handleResize = () => setIsTablet(window.innerWidth < 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className="container">
      {!isTablet ? (
        <div className={`${styles.Banner} subSection mt-5`}>
          <div className="row">
            <div
              className={`${styles.box} col-lg-7 col-md-12 col-sm-12 col-xs-12`}
            >
              <p className="heading">International Retail</p>
              <p className={`${styles.desc} para`}>
                As a leader in{" "}
                <strong>vocational and career-oriented training</strong>, Aptech
                has <strong>840+ learning centres</strong> in{" "}
                <strong>200+ cities</strong> across countries like Vietnam, Egypt, Qatar, Kenya, Malaysia, UAE, Saudi Arabia, and Nigeria. By offering specialized programs tailored to industry
                demands, Aptech provides some of the best{" "}
                <strong>career opportunities</strong> for students and
                professionals willing to excel in their chosen fields.
              </p>
              <p className={`${styles.desc} para`}>
                Aptech’s International Retail busines encompasses a diverse range of
                specialised verticals, each catering to specific industry needs:{" "}
              </p>
            </div>
            <div
              className={`${styles.BusinessBannerTwoCont} col-lg-5 col-md-12 col-sm-12 col-xs-12 d-flex`}
            >
              <img
                src={globalTrainingBannerImg}
                alt=""
                className={classNames(styles.BusinessBannerTwo, "img-fluid")}
              />
            </div>
          </div>
        </div>
      ) : (
        <div className={`${styles.Banner} section mt-5`}>
          <div className="row">
            <div
              className={`${styles.box} col-lg-7 col-md-12 col-sm-12 col-xs-12`}
            >
              <p className="heading">International Retail</p>
              <p className={`${styles.desc} para`}>
                As a leader in{" "}
                <strong>vocational and career-oriented training</strong>, Aptech
                has <strong>840+ learning centres</strong> in{" "}
                <strong>200+ cities</strong> across countries like Vietnam, Egypt, Qatar, Kenya, Malaysia, UAE, Saudi Arabia, and Nigeria. By offering specialized programs tailored to industry
                demands, Aptech provides some of the best{" "}
                <strong>career opportunities</strong> for students and
                professionals willing to excel in their chosen fields.
              </p>
              <p className={`${styles.desc} para`}>
                Aptech’s International Retail busines encompasses a diverse range of
                specialised verticals, each catering to specific industry needs:{" "}
              </p>
            </div>
            <div
              className={`${styles.BusinessBannerTwoCont} col-lg-5 col-md-12 d-flex`}
            >
              <img
                src={globalTrainingBannerImg}
                alt="BusinessBannerOne"
                className={`${styles.BusinessBannerOne} img-fluid col-md-6`}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const IndividualTraining: React.FC = () => {
  interface DataItem {
    src: string;
    title: string;
    description: string;
  }
  const data: DataItem[] = [
    {
      src: ComputerEducationImg,
      title: "Information Technology",
      description:
        "Aptech offers comprehensive IT training programs through its brand Aptech Computer Education, equipping students with essential skills in software development, programming languages, and emerging technologies.",
    },
    {
      src: AptechHardwareImg,
      title: "Hardware & Networking",
      description:
        "Aptech Hardware & Networking Academy provides courses in partnership with top global leaders like Microsoft, Cisco & Red Hat. The academy allows students to enrol for their preferred courses after completing formal schooling and have earned knowledge of basic English, Mathematics, and Science.",
    },
    {
      title: "Animation, VFX, Multimedia & GAMING",
      src: arenaAnimationImg,
      description:
        "Through its two premium brands, Arena Multimedia and MAAC, Aptech focuses on delivering animation and multimedia training, preparing students for high-end careers in animation, VFX, gaming, multimedia, broadcast, and web design.",
    },

    {
      title: "English Language",
      src: aptechEnglishLearningImg,
      description:
        "Aptech English Learning Academy offers expert English language programs that aim to overcome language barrier and empower students with the language skills necessary to succeed globally.",
    },
    {
      title: "Aviation, Hospitality, Luxury Retail, and Tourism",
      src: aptechaviationImg,
      description:
        "A prominent name under the Aptech umbrella, Avalon Academy helps students pursue their career goals in aviation, hospitality, travel & tourism, and luxury retail sectors.",
    },
  ];

  const sectionRefs = useRef<(HTMLElement | null)[]>([]);
  const [hasAnimated, setHasAnimated] = useState<boolean[]>(
    data.map(() => false)
  );
  useEffect(() => {
    const observers = sectionRefs.current.map((ref, index) => {
      if (!ref) return null;

      const observer = new IntersectionObserver(
        ([entry]) => {
          // Only animate if scrolling down and it hasn't animated before
          if (entry.isIntersecting && !hasAnimated[index]) {
            setHasAnimated((prev) => {
              const updated = [...prev];
              updated[index] = true;
              return updated;
            });
          }
        },
        { threshold: 0.2, rootMargin: "0px 0px -50px 0px" } // Ensures it's triggered when scrolling down
      );

      observer.observe(ref);
      return observer;
    });

    return () => {
      observers.forEach((observer) => observer?.disconnect());
    };
  }, [hasAnimated]);
  return (
    <div className="container">
      <div className={`${styles.IndividualTraining} section`}>
        <div className={styles.EBGData}>
          {data.map((item, index) => {
            return (
              <motion.div
                key={index}
                ref={(el) => (sectionRefs.current[index] = el)}
                initial={{ opacity: 0, y: 100 }}
                animate={hasAnimated[index] ? { opacity: 1, y: 0 } : {}}
                transition={{
                  duration: 1,
                  ease: "easeInOut",
                  delay: index * 0.2,
                }}
                className={`row g-0 justify-content-center ${styles.EbgCardRow}`}
              >
                <div className={`col-lg-2 col-md-12 ${styles.EBGImgDiv}`}>
                  <img
                    src={item.src}
                    alt="Aptech Logo"
                    className={`${styles.logoImage} img-fluid`}
                  />
                </div>
                <div className="col-lg-10 col-md-12">
                  <div
                    className={`d-flex flex-column justify-content-end align-items-start ${styles.EbgDataContent}`}
                  >
                    <h6
                      className={`${styles.contentTitle} caps subHeading mb-2 `}
                    >
                      {item.title}
                    </h6>

                    <p
                      className={`${styles.contentDescription} para`}
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    ></p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
      <motion.div
        ref={(el) => (sectionRefs.current[data.length] = el)}
        initial={{ opacity: 0, y: 100 }}
        animate={hasAnimated[data.length] ? { opacity: 1, y: 0 } : {}}
        transition={{
          duration: 1,
          ease: "easeInOut",
          delay: data.length * 0.2,
        }}
        className={`row ${styles.paragraphBottom}`}
      >
        {" "}
        <div className="col-12">
          <p className="para">
            Aptech's <strong>extensive network</strong> across the world ensures
            that students globally have access to{" "}
            <strong>industry-relevant training programs</strong> and avail the
            best career opportunities in their chosen fields. Our international
            reach allows us to adapt to <strong>diverse cultural</strong> and
            <strong> educational requirements</strong>, providing localized
            training solutions that meet <strong>global standards</strong> and{" "}
            <strong>certifications</strong>.
          </p>
        </div>
      </motion.div>
    </div>
  );
};
